import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { api_url } from '../../../js_assets/ConfigApp';
import { GetApi, PostApi } from '../../../js_assets/Network';

import axios from 'axios'
import AppAdminContainer from '../AppAdminContainer'
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';

import { getParameterByName } from '../../../js_assets/getParameterByName'

import Dialog from '@material-ui/core/Dialog';


import DialogTitle from '@material-ui/core/DialogTitle';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}


const styles = theme => ({
    input: {
        paddingRight: 10,
        flex: 1,
    },
    divpadding: {
        width: '50%'
    },
    btn_login: {
        color: 'white',
        padding: '10px 1px',
        border: 'none',
        cursor: 'pointer',
        width: '50%',
        opacity: '0.9',
        borderRadius: '3px',

    },
    btn_Resetfrom: {

        color: 'white',
    }
});

class FormAdminStore extends Component {

    constructor(props) {
        super(props);
        this.state = {
            list_Citys: [],
            successmessage: false,
            store_Id: 0,
            Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
            delivery_Price: []

        };
    }



    componentDidMount() {

        const { Admin_Info } = this.state;
        axios.get(`${api_url}/api/Admin/GetCitys`)
            .then(result => {




                this.setState({ list_Citys: result.data })


                let ActionType_CodeId = getParameterByName("store_Id")


                if (ActionType_CodeId !== null) {


                    if (ActionType_CodeId === "New") {


                    }
                    else {
                        let GetStore = GetApi(`/api/store/GetStore/${Admin_Info.admin_Id}/${ActionType_CodeId}`, Admin_Info.jwT_Token_Admin)

                        GetStore.then(result => {



                            //console.log(result);

                            //console.log(result.store_Id);
                            this.setState({ store_Id: result.store_Id })

                            this.refs.store_Name.value = result.store_Name;
                            this.refs.store_Describe.value = result.store_Describe;
                            this.refs.store_Limit_Order.value = result.store_Limit_Order;
                            this.refs.store_PhoneNumber.value = result.store_PhoneNumber;
                            this.refs.store_Email.value = result.store_Email;
                            this.refs.store_City_Id.value = result.store_City_Id;
                            this.refs.store_Image.value = result.store_Image;

                            this.refs.store_Delivery_Price.value = result.store_Delivery_Price;
                            this.refs.store_VAT_Number.value = result.store_VAT_Number;

                            this.refs.store_Address.value = result.store_Address;

                            this.refs.store_Discount_Percent.value = result.store_Discount_Percent;

                            this.refs.store_Support_Shipment.value = result.store_Support_Shipment;

                            this.refs.store_Shipment_Price.value = result.store_Shipment_Price;

                            this.refs.store_Have_VAT.value = result.store_Have_VAT



                        })

                    }




                }

            })
            .catch(function (error) {

                //console.log(error);
            })





    }

    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    handlClosesuccessmessage = () => {
        this.setState({ successmessage: false })
    }

    Save_Store = (e) => {

        e.preventDefault();

        const { Admin_Info } = this.state;

        var data = new FormData();

        if (this.refs.ImageUP.files.length !== 0) {

            data.append("UploadedImage", this.refs.ImageUP.files[0]);


            let SaveImageStore = PostApi(`/api/store/SaveImageStore/${Admin_Info.admin_Id}`, data, Admin_Info.jwT_Token_Admin);

            SaveImageStore.then(rep => {
                let store = {


                    store_Id: parseInt(this.state.store_Id),
                    store_Name: this.refs.store_Name.value,
                    store_Describe: this.refs.store_Describe.value,
                    store_Limit_Order: this.refs.store_Limit_Order.value,
                    store_PhoneNumber: this.refs.store_PhoneNumber.value,
                    store_Email: this.refs.store_Email.value,
                    store_City_Id: parseInt(this.refs.store_City_Id.value),
                    store_Image: rep,
                    store_Delivery_Price: parseFloat(this.refs.store_Delivery_Price.value),
                    delivery_Price_ID: 1,
                    store_VAT_Number: this.refs.store_VAT_Number.value,
                    store_Address: this.refs.store_Address.value,
                    store_Discount_Percent: this.refs.store_Discount_Percent.value,
                    store_Support_Shipment: this.refs.store_Support_Shipment.value === "true" ? true : false,
                    store_Shipment_Price: this.refs.store_Shipment_Price.value,
                    store_Have_VAT: this.refs.store_Have_VAT.value === "true" ? true : false

                }



                let Save_Store = PostApi(`/api/store/Save_Store/${Admin_Info.admin_Id}`, store, Admin_Info.jwT_Token_Admin)

                Save_Store.then(() => {

                    this.setState({ successmessage: true });


                })

            })

        } else {

            let store = {


                store_Id: parseInt(this.state.store_Id),
                store_Name: this.refs.store_Name.value,
                store_Describe: this.refs.store_Describe.value,
                store_Limit_Order: this.refs.store_Limit_Order.value,
                store_PhoneNumber: this.refs.store_PhoneNumber.value,
                store_Email: this.refs.store_Email.value,
                store_City_Id: parseInt(this.refs.store_City_Id.value),
                store_Image: this.refs.store_Image.value,
                store_Delivery_Price: parseFloat(this.refs.store_Delivery_Price.value),
                delivery_Price_ID: 1,
                store_VAT_Number: this.refs.store_VAT_Number.value,
                store_Address: this.refs.store_Address.value,
                store_Discount_Percent: this.refs.store_Discount_Percent.value,
                store_Support_Shipment: this.refs.store_Support_Shipment.value === "true" ? true : false,
                store_Shipment_Price: this.refs.store_Shipment_Price.value,
                store_Have_VAT: this.refs.store_Have_VAT.value === "true" ? true : false

            }



            let Save_Store = PostApi(`/api/store/Save_Store/${Admin_Info.admin_Id}`, store, Admin_Info.jwT_Token_Admin)

            Save_Store.then(() => {

                this.setState({ successmessage: true });


            })

        }


    }




    render() {
        const { classes } = this.props;
        const { list_Citys } = this.state
        let optionItemsCity = list_Citys.map((citys) => <option value={citys.city_Id} key={citys.city_Id}>{citys.city_Name}</option>);





        return (

            <AppAdminContainer Title={"المتاجر"}>

                <Dialog
                    open={this.state.successmessage}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handlClosesuccessmessage}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        <div className="alertIcon">✔️ <label>تم حفظ </label></div>
                    </DialogTitle>


                </Dialog>

                <Grid justify="center" alignItems="center" container spacing={8}>
                    <form onSubmit={this.Save_Store}>


                        <input ref="store_Id" value={this.state.store_Id} />
                        <br />

                        <span >اسم المتجر </span>
                        <div >

                            <input placeholder=" المتجر" name="store_Name" ref="store_Name" required />
                        </div>

                        <span > المتجر عند ضريية </span>
                        <div >

                            <select ref="store_Have_VAT" name="store_Have_VAT" >
                                <option value={false}>لا</option>
                                <option value={true}>نعم</option>

                            </select>
                        </div>
                        <span > الرقم الضريبي </span>
                        <div >

                            <input placeholder=" اذا وجد الرقم الضريبي" name="store_VAT_Number" ref="store_VAT_Number" required />
                        </div>


                        <span >  عنوان المتجر </span>
                        <div >

                            <input placeholder=" عنوان المتجر " name="store_Address" ref="store_Address" required />
                        </div>


                        <span >  وصف او ملاحضة </span>
                        <div >

                            <input placeholder=" وصف او ملاحضة" name="store_Describe" ref="store_Describe" required />
                        </div>




                        <span >  يدعم الشحن </span>
                        <div >

                            <select ref="store_Support_Shipment" name="store_Support_Shipment" >
                                <option value={false}>لا</option>
                                <option value={true}>نعم</option>

                            </select>
                        </div>

                        <span > قيمة الشحن </span>
                        <div >
                            <input placeholder="حد التسوق " name="store_Shipment_Price" ref="store_Shipment_Price" required />
                        </div>


                        <span > قيمة التوصيل</span>
                        <div >
                            <input placeholder="قيمة التوصيل " name="store_Delivery_Price" ref="store_Delivery_Price" required />
                        </div>



                        <span > حد التسوق</span>
                        <div >
                            <input placeholder="حد التسوق " name="store_Limit_Order" ref="store_Limit_Order" required />
                        </div>

                        <span > خصم المتجر</span>
                        <div >

                            <select ref="store_Discount_Percent" name="store_Discount_Percent" >
                                <option value="0">لايوجد خصم</option>
                                <option value="0.05">5 %</option>
                                <option value="0.10">10 %</option>
                                <option value="0.15">15 %</option>
                                <option value="0.20">20 %</option>
                                <option value="0.25">25 %</option>
                                <option value="0.30">30 %</option>
                                <option value="0.35">35 %</option>
                                <option value="0.40">40 %</option>
                                <option value="0.45">45 %</option>
                                <option value="0.50">50 %</option>
                            </select>
                        </div>


                        <span > رقم الجوال</span>
                        <div >

                            <input placeholder="الجوال" name="store_PhoneNumber" ref="store_PhoneNumber" maxLength="10" minLength="10" pattern="[0-9]*" title="يجب انك تكون 10 رقم" required />
                        </div>

                        <span > الايميل</span>
                        <div >

                            <input placeholder="الايميل" name="store_Email" ref="store_Email" required />
                        </div>

                        <span > المنطقة</span>
                        <div >

                            <select name="store_City_Id" ref="store_City_Id" required>
                                {optionItemsCity}
                            </select>
                        </div>



                        <input ref="store_Image" />

                        <label>صورة </label>
                        <input type="file" ref='ImageUP' accept="image/*" name="fileInput" /><br></br>



                        <Grid style={{ paddingTop: 20, paddingBottom: 20 }} justify="center" alignItems="center" container spacing={8}>
                            <button variant="contained" type="Submit" color="primary" className={classes.btn_login}  >
                                <label>حفظ</label>

                            </button>
                        </Grid>




                    </form>
                </Grid>


            </AppAdminContainer >




        )
    }


}
FormAdminStore.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FormAdminStore);